// missing class names
export const hiddenXs = "hidden-xs";
export const hiddenSm = "hidden-sm";
export const hiddenMd = "hidden-md";
export const hiddenLg = "hidden-lg";
export const hiddenXl = "hidden-xl";
